module.exports = __webpack_public_path__ + "img/chevron_left.4e1ae715.svg";